import projectConfig from '@/config/config';
const baseURL = projectConfig.baseURL;
const api = {
  queryProductionTaxIfExpiration: baseURL + '/tax/productionBusiness/ifExpiration',
  signConfirmProductionTax: baseURL + '/tax/productionBusiness/sign'
};

export default api;
